/* eslint-disable no-console */

import { formatObjectValues, roundValues } from '@/utils/formatUtil';
import { oDGoodsWeight, oDGoodsWeightTotal } from '@/services/oDgoodsWeightInfo';

import BigNumber from 'bignumber.js';
import Filter from '../Filter';
import FilterNew from '../FilterNew';
import { computeWeights } from '@/utils/query';
import { crudRequest } from '@/services/api';
import { getData as getData2 } from '@/components/report/service';
import moment from 'moment';
import { partition } from 'lodash';

// import { message } from 'antd';

const paramsForm = {
  startDate: moment().add(-1, 'days').format('YYYY-MM-DD 00:00:00'),
  endDate: moment().format('YYYY-MM-DD 23:59:59'),
  // 总部没有默认值
  centerFilter: '',
  provinceArea: '',
  centerFilterDepart: '',
  provinceAreaDepart: '',
};

export default {
  namespace: 'odgoodsweightinfoNew',
  state: {
    oDGoodsWeight: [], // 按照公斤段展示的table列表
    oDGoodsWeightTotal: {}, // 按照公斤段展示的table列表 合计数据
    active: 'departure',
    tableColumnsType: 'product', // 表格展示类型
    tableColumns: [
      {
        value: 'product',
        label: '按产品类型展示',
      },
      {
        value: 'kilogram',
        label: '按公斤段展示',
      },
    ], // 表格列类型
    searchParams: { ...paramsForm },
    dataList: [],
    totalRow: {},
    activeChange: {
      active: 'arrive',
      searchParams: { ...paramsForm },
      dataList: [],
      totalRow: {},
    },
  },

  effects: {
    *getDatas(_, { put, select, call }) {
      const {
        tableColumnsType,
        searchParams: {
          centerFilter,
          provinceArea,
          startDate,
          endDate,
          centerFilterDepart,
          provinceAreaDepart,
        },
      } = yield select(({ odgoodsweightinfoNew }) => odgoodsweightinfoNew);
      // if (!centerFilter && !provinceArea && !centerFilterDepart && !provinceAreaDepart) {
      // return message.error("至少选择一个查询条件！")
      // }

      // 根据展示的产品类型进行划分
      console.log('tableColumnsType', tableColumnsType);

      const ODGoodsWeightQueryVo = {
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'), // 时间区间-开始
        endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'), // 时间区间-结束
        originCenter: centerFilter?.name, // 始发分拨
        originCenterCode: centerFilter?.code, // 始发分拨编码
        destinationCenter: centerFilterDepart?.name, // 目的分拨
        destinationCenterCode: centerFilterDepart?.code, // 目的分拨编码
        originProvinceArea: provinceArea?.name, // 始发营运区
        originProvinceAreaCode: provinceArea?.code, // 始发营运区编码
        destinationProvinceArea: provinceAreaDepart?.name, // 目的营运区
        destinationProvinceAreaCode: provinceAreaDepart?.code, // 目的营运区编码
        dataType: 1,
      };
      const { data: ODGoodsWeightTotal = [] } = yield call(
        oDGoodsWeightTotal,
        ODGoodsWeightQueryVo,
      );
      // const formatODGoodsWeightTotal = formatObjectValues(ODGoodsWeightTotal, 0)
      const formatODGoodsWeightTotal = ODGoodsWeightTotal;
      console.log(
        '%c [ ODGoodsWeightTotal ]-96',
        'font-size:13px; background:pink; color:#bf2c9f;',
        ODGoodsWeightTotal,
      );
      console.log(
        '%c [ formatODGoodsWeightTotal ]-97',
        'font-size:13px; background:pink; color:#bf2c9f;',
        formatODGoodsWeightTotal,
      );
      if (tableColumnsType === 'product') {
        console.log('按产品类型展示');
        const generateMap = (arr, getHash) => {
          const map = new Map();
          if (arr?.length > 0) {
            arr.forEach((item) => {
              map.set(
                item.originCenter + // 始发分拨
                  item.destinationCenter + // 目的分拨
                  item.originProvinceArea + // 始发营运区
                  item.destinationProvinceArea + // 目地营运区
                  (getHash ? getHash(item) : ''),
                item.calcWeight,
              );
            });
          }
          return map;
        };
        /**
         * 生成票据映射表
         *
         * @param arr 票据数组
         * @param getHash 自定义哈希函数，用于生成票据的唯一标识（可选）
         * @returns 返回一个Map对象，其中键为票据的唯一标识（由originCenter、destinationCenter、originProvinceArea、destinationProvinceArea和getHash函数生成），值为票据本身
         */
        const generateTicketMap = (arr) => {
          const map = new Map();
          if (arr?.length > 0) {
            // arr.forEach(item => {
            // console.log('%c [ item ]-80', 'font-size:13px; background:pink; color:#bf2c9f;', item)
            // console.log('%c [ item ]-80', 'font-size:13px; background:pink; color:#bf2c9f;', item.ticket)
            // map.set(
            //   item.originCenter + // 始发分拨
            //   item.destinationCenter + // 目的分拨
            //   item.originProvinceArea + // 始发营运区
            //     item.destinationProvinceArea, // 目地营运区
            //   item.ticket,
            // );
            // });
            arr.forEach((item) => {
              const key =
                item.originCenter +
                item.destinationCenter +
                item.originProvinceArea +
                item.destinationProvinceArea;
              const existingTicket = map.get(key) || 0;
              map.set(key, existingTicket + item.ticket);
            });
          }
          return map;
        };
        const filter = FilterNew({
          originCenter: centerFilter?.name,
          originProvinceArea: provinceArea?.name,
          destinationCenter: centerFilterDepart?.name,
          destinationProvinceArea: provinceAreaDepart?.name,
          startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
          endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'),
        });
        const reqAll = filter.map((filterItem) =>
          getData2({ ...filterItem, dataType: 1 }, 'druid2'),
        );
        const dataSource = yield Promise.all(reqAll);
        const [
          dataList, // 全部数据
          lengthTime_data, // lengthOfTime
          product_data, // MINI电商小件 和 MINI电商大件
          goodsType_data, // 网络
          // longSum_data, // 含有 totalCalcWeight 和 ticket 的数据
          // lessThan300,
          greaterThan300,
        ] = dataSource;
        console.log(
          '%c [ dataSource ]-110',
          'font-size:13px; background:pink; color:#bf2c9f;',
          dataSource,
        );

        // console.log(
        //   '%c [ longSum_data ]-112',
        //   'font-size:13px; background:pink; color:#bf2c9f;',
        //   longSum_data,
        // );
        /// 存hash
        // const [lessThan300_data, greaterThan300_data] = partition(
        //   longSum_data,
        //   item => item.ticket <= 300,
        // );
        // console.log(
        //   '%c [ <=300kg, >300kg ]-115',
        //   'font-size:13px; background:pink; color:#bf2c9f;',
        //   lessThan300_data,
        //   greaterThan300_data,
        // );
        const lengthTime_map = generateMap(lengthTime_data, (item) => item.lengthOfTime);
        console.log(
          '%c [ 产品时效 ]-117',
          'font-size:13px; background:pink; color:#bf2c9f;',
          lengthTime_map,
        );
        const product_map = generateMap(product_data, (item) => item.productType);
        console.log(
          '%c [ 产品数据 ]-119',
          'font-size:13px; background:pink; color:#bf2c9f;',
          product_map,
        );
        const greaterThan300_map = generateMap(greaterThan300);
        console.log(
          '%c [ >300kg map ]-121',
          'font-size:13px; background:pink; color:#bf2c9f;',
          greaterThan300_map,
        );
        // const lessThan300_map = generateMap(lessThan300);
        // console.log(
        //   '%c [ <=300kg map ]-123',
        //   'font-size:13px; background:pink; color:#bf2c9f;',
        //   lessThan300_map,
        // );
        const goodsType_map = generateMap(goodsType_data);
        console.log(
          '%c [ 网络 map ]-125',
          'font-size:13px; background:pink; color:#bf2c9f;',
          goodsType_map,
        );
        const generateTicketThan300kMap = generateTicketMap(greaterThan300);
        // const generateTicketThan300kMap = generateTicketMap(greaterThan300_data);
        console.log(
          '%c [ >300kg 票数 ]-127',
          'font-size:13px; background:pink; color:#bf2c9f;',
          generateTicketThan300kMap,
        );
        // const generateTicketLess300kMap = generateTicketMap(lessThan300)
        // const generateTicketLess300kMap = generateTicketMap(lessThan300_data);
        // console.log(
        //   '%c [ <=300kg 票数 ]-129',
        //   'font-size:13px; background:pink; color:#bf2c9f;',
        //   generateTicketLess300kMap,
        // );
        dataList.forEach((item, i) => {
          if (item.destinationCenter) {
            item.originCenter2 = item.originCenter?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationCenter2 = item.destinationCenter?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = item.originProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = item.destinationProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.routePath2 = item.originCenter2 + '-' + item.destinationCenter2;
            item.index = i;

            //#region 拼接数据
            item.weight0 = item.calcWeight; // 总重量
            const prefix =
              item.originCenter +
              item.destinationCenter +
              item.originProvinceArea +
              item.destinationProvinceArea;
            // 产品类型
            // <=300kg
            item.weight1 = item.calcWeight - greaterThan300_map.get(prefix);
            // <=300kg票数
            // item.weight2 = generateTicketLess300kMap.get(prefix) || 0;
            item.weight2 = item.ticket - generateTicketThan300kMap.get(prefix) || 0;
            // >300kg
            item.weight3 = greaterThan300_map.get(prefix) || 0;
            // >300kg票数
            item.weight4 = generateTicketThan300kMap.get(prefix) || 0;
            // 网络
            item.weight5 = goodsType_map.get(prefix) || 0;
            item.weight6 = product_map.get(prefix + '整车') || 0;
            item.weight7 = product_map.get(prefix + '定时达') || 0;
            item.weight8 = product_map.get(prefix + '安心达') || 0;
            item.weight9 = product_map.get(prefix + 'MINI电商小件') || 0;
            item.weight10 = product_map.get(prefix + 'MINI电商大件') || 0;
            item.weight11 = product_map.get(prefix + '精准零担') || 0;
            item.weight12 = lengthTime_map.get(prefix + '产品时效') || 0;
          }
        });

        const totalRow = { totalRow: '合计', length: dataSource.length - 1 };
        // dataList.forEach(item => {
        //   for (let i = 0; i < 12; i++) {
        //     totalRow[`weight${i}`] = Number.parseFloat(
        //       new BigNumber(totalRow[`weight${i}`] || 0).plus(item[`weight${i}`]).toString(),
        //     );
        //     if (i !== 2 && i !== 4) { // Check if i is not 2 or 4
        //       item[`weight${i}`] = computeWeights(item[`weight${i}`], 2);
        //     }
        //   }
        // });
        dataList.forEach((item) => {
          for (let i = 0; i < 14; i++) {
            totalRow[`weight${i}`] = Number.parseFloat(
              new BigNumber(totalRow[`weight${i}`] || 0).plus(item[`weight${i}`] || 0).toString(),
            );
            if (i !== 2 && i !== 4) {
              let weight = item[`weight${i}`];
              if (typeof weight === 'number') {
                item[`weight${i}`] = computeWeights(weight, 2);
              }
            }
          }
        });

        yield put({
          type: 'updateState',
          payload: {
            dataList,
            totalRow,
            oDGoodsWeight: [],
            oDGoodsWeightTotal: formatODGoodsWeightTotal,
          },
        });
        console.log(
          '%c [ totalRow ]-190',
          'font-size:13px; background:pink; color:#bf2c9f;',
          totalRow,
        );
        console.log(
          '%c [ dataList ]-191',
          'font-size:13px; background:pink; color:#bf2c9f;',
          dataList,
        );
      } else {
        console.log('按照公斤段展示');
        const { data: ODGoodsWeight = [] } = yield call(oDGoodsWeight, ODGoodsWeightQueryVo);
        // const roundODGoodsWeight = roundValues(ODGoodsWeight);
        const roundODGoodsWeight = ODGoodsWeight;
        console.log(
          '%c [ ODGoodsWeight ]-256',
          'font-size:13px; background:pink; color:#bf2c9f;',
          ODGoodsWeight,
        );
        console.log(
          '%c [ roundODGoodsWeight ]-257',
          'font-size:13px; background:pink; color:#bf2c9f;',
          roundODGoodsWeight,
        );
        yield put({
          type: 'updateState',
          payload: {
            dataList: [],
            totalRow: [],
            oDGoodsWeight: roundODGoodsWeight,
            oDGoodsWeightTotal: formatODGoodsWeightTotal,
          },
        });
      }
    },
    *getData(_, { put, select }) {
      crudRequest('/api/route/odgoodsweightinfoNew/search'); // 日志
      const {
        searchParams: {
          centerFilter,
          provinceArea,
          startDate,
          endDate,
          centerFilterDepart,
          provinceAreaDepart,
        },
      } = yield select(({ odgoodsweightinfoNew }) => odgoodsweightinfoNew);
      // if (!centerFilter && !provinceArea && !centerFilterDepart && !provinceAreaDepart) {
      // return message.error("至少选择一个查询条件！")
      // }
      const filter = Filter({
        originCenter: centerFilter?.name,
        originProvinceArea: provinceArea?.name,
        destinationCenter: centerFilterDepart?.name,
        destinationProvinceArea: provinceAreaDepart?.name,
        startDate,
        endDate,
      });

      const reqAll = filter.map((filterItem) => getData2({ ...filterItem, dataType: 1 }, 'druid2'));
      const dataSource = yield Promise.all(reqAll);
      let dataList = [];
      if (dataSource.length > 0) {
        dataSource[0].forEach((item, i) => {
          if (item.destinationCenter) {
            const originCenter = item.originCenter;
            const destinationCenter = item.destinationCenter;
            const originProvinceArea = item.originProvinceArea;
            const destinationProvinceArea = item.destinationProvinceArea;
            item.originCenter2 = originCenter?.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '');
            item.destinationCenter2 = destinationCenter?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = originProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = item.originProvinceArea2?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = destinationProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = item.destinationProvinceArea2?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.routePath2 = item.originCenter2 + '-' + item.destinationCenter2;
            const obj = { index: i, ...item, weight0: item.calcWeight };
            dataList.push(obj);
          }
        });

        for (let i = 1; i < dataSource.length; i++) {
          const dsItem = dataSource[i];
          for (let j = 0; j < dataList.length; j++) {
            const firstItem = dataList[j];
            dataList[j][`weight${i}`] = 0;
            dsItem.find((lastItem) => {
              if (
                firstItem.originCenter === lastItem.originCenter &&
                firstItem.destinationCenter === lastItem.destinationCenter
                // && firstItem.originProvinceArea === lastItem.originProvinceArea
              ) {
                dataList[j] = { ...firstItem, [`weight${i}`]: lastItem.calcWeight };
                return true;
              }
              return false;
            });
          }
        }
      }
      const totalRow = { totalRow: '合计', length: dataSource.length - 1 };
      dataList.forEach((item) => {
        for (let i = 0; i < dataSource.length; i++) {
          if (!totalRow[`weight${i}`]) {
            totalRow[`weight${i}`] = 0;
          }
          totalRow[`weight${i}`] = Number.parseFloat(
            new BigNumber(totalRow[`weight${i}`]).plus(item[`weight${i}`]).toString(),
          );
          item[`weight${i}`] = computeWeights(item[`weight${i}`], 2);
        }
      });
      yield put({ type: 'updateState', payload: { dataList, totalRow } });
      console.log(
        '%c [ dataList ]-372',
        'font-size:13px; background:pink; color:#bf2c9f;',
        dataList,
      );
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    // eslint-disable-next-line no-unused-vars
    updateActive(state, { payload }) {
      const { activeChange, ...states } = state;
      return {
        ...activeChange,
        activeChange: { ...states, searchParams: { ...states.searchParams } },
      };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
